const entities = [
  // Data
  require('./app/redux'),
]

// Make sure all entities have a defined key
const reducers = entities.reduce((acc, entity) => {
  if (!entity.key) {
    console.error('Missing entity key')
  }
  acc[entity.key] = entity.reducer
  return acc
}, {})

export default reducers
